import { useState } from "react";
import readXlsxFile from "read-excel-file";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";
import ArrowDownwardOutlinedIcon from "@material-ui/icons/ArrowDownwardOutlined";
import { useAuth } from "../../Auth/Auth";
import {
  UploadAssessmentHeader,
  UploadAssessmentButton,
  UploadAssessmentContainer,
  AssesmentButton,
  UploadAssessMentButtonWrapper,
} from "./Modal.style";
import { ModalWrapper, ModalContainer } from "../Dashboard/Dashboard.style";
import OBQSampleFile from "../../sample-excels/OBQ-sample.xlsx";
import CBQSampleFile from "../../sample-excels/CBQ-sample.xlsx";
import QuestionParser from "../../utils/parsers/questionParser";

function UploadAssessmentComponent({ type, setModal, handleUploadAssessment }) {
  const [question, setQuestions] = useState([]);
  const [fileName, setFileName] = useState("");
  const { DisplaySnackbar } = useAuth();

  const fileUploadHandler = async (e) => {
    let files = e.target.files[0];

    const nameList = files.name.split(".");
    const type = nameList[nameList.length - 1];
    let ques = [];
    if (type === "xlsx") {
      await readXlsxFile(files).then(async (rows) => {
        let headers = rows[0];
        for (let index = 1; index < rows.length; index++) {
          const row = rows[index];
          let newObj = {};
          for (let i in headers) {
            newObj[headers[i]] = row[i];
          }
          const newObject = new QuestionParser(newObj).parseQuestion(index);
          ques.push(newObject);
        }
        setFileName(files.name);
      });
    } else if (type === "csv") {
      const reader = new FileReader();
      reader.readAsText(files);
      reader.onload = async (e) => {
        const rows = e.target.result.split("\n");
        let headers = rows[0].replace("\r", "").split(",");
        rows.forEach(async (row, index) => {
          row.replace("\r", "");
          row = row.split(",");
          if (index !== 0) {
            let newObj = {};
            for (let i in headers) {
              newObj[headers[i]] = row[i];
              // console.log(row[i]);
            }
            try {
              const newObject = new QuestionParser(newObj).parseQuestion(index);
              ques.push(newObject);
            } catch (err) {
              console.log(err);
            }
          }
        });
        setFileName(files.name);
      };
    } else {
      DisplaySnackbar("Upload .csv or xlsx sheet", "error");
      setFileName("");
    }
    console.log(ques);
    setQuestions(ques);
  };
  const handleUploadFile = () => {
    if (!question.length) {
      DisplaySnackbar("Your file doesn't have any Question", "error");
      return;
    }
    handleUploadAssessment(question);
  };
  return (
    <ModalWrapper>
      <ModalContainer style={{ minWidth: "350px", minHeight: "200px" }}>
        <UploadAssessmentHeader>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "1.1rem",
            }}
          >
            <CloudUploadOutlinedIcon className="icon" />
            UPLOAD QUESTIONS
          </div>
          <div>
            <a
              href={type === "competency" ? CBQSampleFile : OBQSampleFile}
              download
              style={{ textDecoration: "none" }}
            >
              <UploadAssessmentButton>
                <ArrowDownwardOutlinedIcon className="icon" />
                Export File
              </UploadAssessmentButton>
            </a>
          </div>
        </UploadAssessmentHeader>
        <UploadAssessmentContainer width={"100%"} height={"fit-content"} margin={"30px auto"}>
          <div className="text">File</div>
          <div style={{margin:"10px 0"}}>
            <label for="uploadFile">
              <span className="firstLabel file">FILE</span>
              <span className="secondLabel file">
                {`${fileName ? fileName : "NO SELECTED FILE"}`}{" "}
              </span>
            </label>
            <input
              type="file"
              id="uploadFile"
              onChange={(e) => fileUploadHandler(e)}
              style={{ display: "none" }}
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            />
          </div>
          <div className="text">
            Upload <span style={{ color: "#5CE0D2" }}>.xlsx</span>
          </div>
          <br/>
          <div style={{width:"300px",fontSize:"0.9rem"}}>
            Note: The "Correct Answers" column with multiple answers must be separated using "[BLK]" instead of a comma.
          </div>
        </UploadAssessmentContainer>
        <UploadAssessMentButtonWrapper>
          <AssesmentButton onClick={() => setModal(false)}>
            Cancel
          </AssesmentButton>
          <AssesmentButton onClick={() => handleUploadFile()}>
            Upload
          </AssesmentButton>
        </UploadAssessMentButtonWrapper>
      </ModalContainer>
    </ModalWrapper>
  );
}

export default UploadAssessmentComponent;
